import { Eclipse, Rocket, WandSparkles, LucideIcon } from "lucide-react"

// Export the interfaces
export interface CardTypeOption {
  name: string;
  baseType: typeof BASE_CARD_TYPES[keyof typeof BASE_CARD_TYPES];
}

export interface CategoryField {
  [key: string]: string[] | CardTypeOption[];
}

export interface CardCategory {
  label: string;
  icon: LucideIcon;
  themeId: number;
  fields: CategoryField;
}

interface CardCategories {
  [key: string]: CardCategory
}

// Base card types (matching backend)
export const BASE_CARD_TYPES = {
    CHARACTER: 'CHARACTER',
    ENVIRONMENT: 'ENVIRONMENT',
    POWER: 'POWER'
} as const;

export const CARD_CATEGORIES: CardCategories = {
  fantasy: {
    icon: WandSparkles,
    label: "Fantasy",
    themeId: 1,
    fields: {
      type: [
        { name: 'Creature', baseType: BASE_CARD_TYPES.CHARACTER },
        { name: 'Hero', baseType: BASE_CARD_TYPES.CHARACTER },
        { name: 'Location', baseType: BASE_CARD_TYPES.ENVIRONMENT },
        { name: 'Spell', baseType: BASE_CARD_TYPES.POWER }
      ],
      element: ["Fire", "Water", "Earth", "Air", "Light", "Dark"],
      artStyle: ["Renaissance Oil Painting", "Pre-Raphaelite Fantasy", "Baroque Hellscapes", "Dutch Golden Age Style", "Chiaroscuro Fantasy Art"]
    }
  },
  tarot: {
    icon: Eclipse,
    label: "Tarot",
    themeId: 2,
    fields: {
      type: [
        { name: 'Major Arcana', baseType: BASE_CARD_TYPES.CHARACTER },
        { name: 'Court Card', baseType: BASE_CARD_TYPES.CHARACTER },
        { name: 'Minor Arcana', baseType: BASE_CARD_TYPES.POWER }
      ],
      artStyle: ["Classical Renaissance", "Art Nouveau Mystical", "Dark Victorian Gothic", "Medieval Illuminated", "Symbolist Ethereal"],
    }
  },
  ufo: {
    icon: Rocket,
    label: "UFO",
    themeId: 4,
    fields: {
      type: [
        { name: 'Alien', baseType: BASE_CARD_TYPES.CHARACTER },
        { name: 'UFO', baseType: BASE_CARD_TYPES.CHARACTER },
        { name: 'Location', baseType: BASE_CARD_TYPES.ENVIRONMENT },
        { name: 'Power', baseType: BASE_CARD_TYPES.POWER }
      ],
      artStyle: ["Steampunk Illustration", "Gothic Horror", "Art Nouveau Fantasy", "Dark Victorian Gothic", "Symbolist Ethereal"],
    }
  }
} as const;